import React, { Fragment } from 'react';
import { useSnackbar } from 'notistack';
import IconButton from '@mui/material/IconButton';
import { both, equals, has, pathOr } from 'ramda';
import { Theme, Divider } from '@mui/material';
import Typography from '@mui/material/Typography';
import makeStyles from '@mui/styles/makeStyles';
import { getTheme } from 'src/utilities/siteSettings';
const theme = getTheme();

const useStyles = makeStyles((theme: Theme) => ({
  success: {
    backgroundColor: `${theme.palette.success.main} !important`,
  },
  error: {
    backgroundColor: `${theme.palette.error.main} !important`,
  },
  warning: {
    backgroundColor: `${theme.palette.warning.main} !important`,
  },
}));
interface Notification {
  msg: string;
  variant: string;
  autoHideDuration?:number;
}

const isNotificationPayload = (val: any): val is Notification => both(has('msg'), has('variant'))(val);

const useNotification = () => {
  const classes = useStyles();

  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  const action = (key: any) => (
    <Fragment>
      <Divider
        dir="vertical"
        style={{
          height: 20,
          width: 1,
          backgroundColor: theme.palette.mainLight,
        }}
      />
      <IconButton
        onClick={() => {
          closeSnackbar(key);
        }}
      >
        <Typography color="white" sx={{ textDecoration: 'underline' }}>
          Close
        </Typography>
      </IconButton>
    </Fragment>
  );

  const getTheme = (notification: Notification): any => {
    if (equals(pathOr('info', ['variant'], notification), 'success')) {
      return classes.success;
    } else if (equals(pathOr('info', ['variant'], notification), 'error')) {
      return classes.error;
    } else if (equals(pathOr('info', ['variant'], notification), 'warning')) {
      return classes.warning;
    }
  };
  const sendNotification = (notification: Notification) =>
    enqueueSnackbar(
      <Typography ml={2} variant="body2">
        {pathOr('', ['msg'], notification)}
      </Typography>,
      {
        variant: pathOr('info', ['variant'], notification),
        autoHideDuration:pathOr(3000, ['autoHideDuration'], notification),
        action,
        className: getTheme(notification),
        preventDuplicate: true,
      }
    );

  return [sendNotification];
};

export default useNotification;
export { Notification, isNotificationPayload };
